<mat-slide-toggle
  [attr.data-testid]="testId() ? testId() + '-toggle' : null"
  [color]="color()"
  [checked]="currentValue"
  [disabled]="ngControl.disabled"
  [labelPosition]="labelPosition()"
  (change)="setValue($event)"
>
  <div class="eiq-slide-toggle">
    <span class="fs__sm fw__500">
      {{ label() }}
    </span>
    <span class="fs__sm fw__400 caption">
      <ng-content select="[slot=hint]"></ng-content>
    </span>
  </div>
</mat-slide-toggle>
